import authAxios, { authHeader } from "./data";

const getProgress = async (id: string) => {
  const result = await authAxios.get(`/api/BackgroundTask/${id}`, {
    headers: authHeader(),
  });

  return result.data;
};

const cancelTask = async (id: string) => {
  const result = await authAxios.post(
    `/api/BackgroundTask/cancel/${id}`,
    null,
    {
      headers: authHeader(),
    }
  );

  return result.data;
};

const BackGroundService = {
  getProgress,
  cancelTask,
};

export default BackGroundService;
